import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { ItemService } from '../../services/item.service';
import { Router } from '@angular/router';
import { Spot } from '../../models/Item';
import { Chart } from 'chart.js';
import { TitleCasePipe } from '@angular/common';



@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css']
})


export class BrandsComponent implements OnInit {

  dataSource_adv_brands_tab;
  dataSource_adv_brands_days_tab;
  dataSource_adv_channel_tab;
  secondary_dataSource_adv_channel_tab: any;
  displayedColumns = ['brand', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof', 'active_days'];
  displayedColumns_day = ['day', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof'];
  displayedColumns_channel = ['channel', 'net_spend', 'avg_spend', 'total_minutes', 'count', 'sos', 'som', 'sof'];

  @ViewChild('sort1') sort1: MatSort;
  @ViewChild('sort2') sort2: MatSort;
  @ViewChild('sort3') sort3: MatSort;
  @ViewChild('sort4') sort4: MatSort;
  @ViewChild('paginator1') paginator1: MatPaginator;
  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild('paginator3') paginator3: MatPaginator;
  @ViewChild('paginator4') paginator4: MatPaginator;


  ngOnInit() {
    let parameters: any = { section_name: 'Advertisers', page_name: 'Brands' }
    this.itemService.logEvent('onPageView', parameters);

    if (this.itemService.remeberAdv) {
      this.itemService.selected_adv = this.itemService.remeberAdv;
    }
   
    // this.itemService.selected_adv = null;
    // this.itemService.selected_adv_brand = null;
    // this.itemService.secondary_selected_adv = null;
    // this.itemService.secondary_selected_adv_brand = null;
    // this.itemService.selected_adv_channel = null;
    this.itemService.selected_cat = null;
    this.itemService.url = this.router.url;
    this.itemService.showSpinner = true;
    // this.itemService.dateChangeDetector();
    if(this.itemService.dataAvailable){
      // console.log('Advertisers Block')
      this.itemService.advertisers();
      this.itemService.showSpinner = false;
    } else {
      // console.log('Date Change Block')
      this.itemService.dateChangeDetector();
    }

    setTimeout(() => {
      this.itemService.dataSource_adv_brands_tab.sort = this.sort1;
      this.itemService.dataSource_adv_brands_tab.paginator = this.paginator1;
      this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
      this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;
    }, 8000);
    // this.itemService.charts_adv_Brands(); 
    this.itemService.showSpinner = false;   
  }


  constructor(public itemService: ItemService, public router: Router, public titlecasePipe: TitleCasePipe) { }



  chart = [];

  // public data: any[];
  // dateSelected: any;
  public advertiser: any;
  public daterange: any = {};
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },

    alwaysShowCalendars: false,
    startDate: this.itemService.sd,
    endDate: this.itemService.ed,
    minDate: '01/01/2017',
    opens: 'left',
    showWeekNumbers: true,
    ranges: {
      // 'Yesterday': [
      //     '2018-02-26T07:00:33.456Z',
      //     '2018-02-26T07:00:33.456Z'
      // ],
      'Last 7 Days': [
        '01/01/2017',
        '31/03/2018',
      ],
      'Last 30 Days': [
        '03/02/2018',
        '03/31/2018'
      ],
      'This Month': [
        '03/01/2018',
        '03/31/2018'
      ],
      'Last Month': [
        '02/01/2018',
        '02/28/2018'
      ]
    },
  };



  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;

    // or manupulat your own internal property
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;

    let start;
    let end;
    start = new Date(this.daterange.start);
    end = new Date(this.daterange.end);


    this.itemService.startDateTemp = start;
    this.itemService.endDateTemp = end;

    // start Date Function
    const sd_date = ('0' + start.getDate()).slice(-2);
    const sd_Month = ('0' + (start.getMonth() + 1)).slice(-2);
    const sd_year = start.getFullYear();

    const startDate = ((sd_Month) + '-' + sd_date + '-' + sd_year);
    this.itemService.startDate = startDate;
    // console.log(this.itemService.startDate);

    // end Date Function
    const ed_date = ('0' + end.getDate()).slice(-2);
    const ed_Month = ('0' + (end.getMonth() + 1)).slice(-2);
    const ed_year = end.getFullYear();

    const endDate = ((ed_Month) + '-' + ed_date + '-' + ed_year);
    this.itemService.endDate = endDate;
    // console.log(this.itemService.endDate);

    // dateChanged Function


    this.itemService.startDateTemp = new Date(startDate)
    this.itemService.endDateTemp = new Date(endDate)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;



    let advertiserSelected = this.itemService.selected_adv ? this.itemService.selected_adv : 'Not Selected';
    let brandSelected = this.itemService.selected_adv_brand ? this.itemService.selected_adv_brand : 'Not Selected';
    let advertiserSelected_sec = this.itemService.secondary_selected_adv ? this.itemService.secondary_selected_adv : 'Not Selected';
    let brandSelected_sec = this.itemService.secondary_selected_adv_brand ? this.itemService.secondary_selected_adv_brand : 'Not Selected';
    let parameters: any = {
      section_name: 'Advertisers',
      page_name: 'Brands',
      advertiser: advertiserSelected,
      brand: brandSelected,
      advertiser_secondary: advertiserSelected_sec,
      brand_secondary: brandSelected_sec,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onDateChange', parameters);

    this.itemService.dateChangeDetector();

    setTimeout(() => {

    }, 10000);
  }


  onChange(value) {


    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;

    let parameters: any = {
      section_name: 'Advertisers',
      page_name: 'Brand',
      advertiser: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.selected_adv = value;
    this.itemService.selected_adv_brand = null;
    this.itemService.secondary_selected_adv = null;
    this.itemService.secondary_selected_adv_brand = null;
    this.showVar = false;
    // this.itemService.seasonality_trend_chart.destroy();
    // this.itemService.total_spend_chart.destroy();
    // this.itemService.total_minutes_chart.destroy();
    // this.itemService.total_count_chart.destroy();
    // this.itemService.top_slots_chart.destroy();

    this.itemService.advertisers();

    this.itemService.dataSource_adv_brands_tab.sort = this.sort1;
    this.itemService.dataSource_adv_brands_tab.paginator = this.paginator1;
    this.itemService.dataSource_adv_brands_days_tab.sort = this.sort2;
    this.itemService.dataSource_adv_brands_days_tab.paginator = this.paginator2;
    this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
    this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;


  }


  showVar: boolean = false;
  toggleChild() {

    
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;

    let parameters: any = {
      section_name: 'Advertisers',
      page_name: 'Brand',
      advertiser: this.itemService.selected_adv,
      brand: this.itemService.selected_adv_brand,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onCompareClicked', parameters);

    this.showVar = !this.showVar;
    if (!this.showVar) {
      this.itemService.secondary_selected_adv = null;
      this.itemService.secondary_selected_adv_brand = null;
      this.itemService.advertisers();
    }

  }

  onChangebrand(value) {

    
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;


    let parameters: any = {
      section_name: 'Advertisers',
      page_name: 'Brand',
      advertiser: this.itemService.selected_adv,
      brand: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onBrandChange', parameters);

    this.itemService.selected_adv_brand = value;

    // this.itemService.seasonality_trend_chart.destroy();
    // this.itemService.total_spend_chart.destroy();
    // this.itemService.total_minutes_chart.destroy();
    // this.itemService.total_count_chart.destroy();
    // this.itemService.top_slots_chart.destroy();

    // this.itemService.brand_numbers.destroy();
    this.itemService.advertisers();

    setTimeout(() => {
      this.itemService.dataSource_adv_brands_tab.sort = this.sort1;
      this.itemService.dataSource_adv_brands_tab.paginator = this.paginator1;
      this.itemService.dataSource_adv_brands_days_tab.sort = this.sort2;
      this.itemService.dataSource_adv_brands_days_tab.paginator = this.paginator2;
      this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
      this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;
    }, 1000);

  }


  secondary_onChangebrand(value) {

    
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;

    let parameters: any = {
      section_name: 'Advertisers',
      page_name: 'Brand',
      advertiser: this.itemService.selected_adv,
      brand: this.itemService.selected_adv_brand,
      advertiser_sec: this.itemService.secondary_selected_adv,
      brand_sec: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onSecondaryBrandChange', parameters);

    this.itemService.secondary_selected_adv_brand = value;
    this.itemService.top_slots_chart.destroy();
    // this.itemService.seasonality_trend_chart.destroy();
    // this.itemService.total_spend_chart.destroy();
    // this.itemService.total_minutes_chart.destroy();
    // this.itemService.total_count_chart.destroy();
    // this.itemService.top_slots_chart.destroy();
    // console.log(this.itemService.secondary_selected_adv_brand);
    // this.itemService.brand_numbers.destroy();

    setTimeout(() => {
      this.itemService.secondary_dataSource_adv_channel_tab.sort = this.sort4;
      this.itemService.secondary_dataSource_adv_channel_tab.paginator = this.paginator4;
    }, 4000);


    this.itemService.compareAdvertisers();

    // setTimeout(() => {
    //   this.itemService.dataSource_adv_brands_tab.sort = this.sort1;
    //   this.itemService.dataSource_adv_brands_tab.paginator = this.paginator1;
    //   this.itemService.dataSource_adv_brands_days_tab.sort = this.sort2;
    //   this.itemService.dataSource_adv_brands_days_tab.paginator = this.paginator2;
    //   this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
    //   this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;
    // }, 1000);

  }

  secondary_onChange(value) {
    
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;


    let parameters: any = {
      section_name: 'Advertisers',
      page_name: 'Brand',
      advertiser: this.itemService.selected_adv,
      brand: this.itemService.selected_adv_brand,
      advertiser_sec: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onSecondaryAdvertiserChange', parameters);

    this.itemService.secondary_selected_adv = value;
    this.itemService.secondary_selected_adv_brand = null;


    // this.itemService.seasonality_trend_chart.destroy();
    // this.itemService.total_spend_chart.destroy();
    // this.itemService.total_minutes_chart.destroy();
    // this.itemService.total_count_chart.destroy();
    // this.itemService.top_slots_chart.destroy();

    this.itemService.compareAdvertisers();

    // this.itemService.dataSource_adv_brands_tab.sort = this.sort1;
    // this.itemService.dataSource_adv_brands_tab.paginator = this.paginator1;
    // this.itemService.dataSource_adv_brands_days_tab.sort = this.sort2;
    // this.itemService.dataSource_adv_brands_days_tab.paginator = this.paginator2;
    // this.itemService.dataSource_adv_channel_tab.sort = this.sort3;
    // this.itemService.dataSource_adv_channel_tab.paginator = this.paginator3;


  }



}


// WEBPACK FOOTER //
// ./src/app/advertisers/brands/brands.component.ts